webpackJsonp([35783957827783],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var frontCategory = function (_React$Component) {
	  _inherits(frontCategory, _React$Component);
	
	  function frontCategory(props) {
	    _classCallCheck(this, frontCategory);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  frontCategory.prototype.render = function render() {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: this.props.url, className: 'has-text-centered' },
	      _react2.default.createElement(
	        'div',
	        { style: { height: '200px', width: '200px', borderRadius: '100%', overflow: 'hidden', display: 'block', margin: '0 auto' } },
	        _react2.default.createElement('img', { src: this.props.img, alt: this.props.title, style: { height: '200px', width: 'auto', maxWidth: 'none' } })
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { color: 'black' } },
	        this.props.desc
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'is-size-4', style: { color: '#666' } },
	        'View More >>'
	      )
	    );
	  };
	
	  return frontCategory;
	}(_react2.default.Component);
	
	exports.default = frontCategory;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__(18);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _frontCat = __webpack_require__(215);
	
	var _frontCat2 = _interopRequireDefault(_frontCat);
	
	var _LangmanConstruction = __webpack_require__(480);
	
	var _LangmanConstruction2 = _interopRequireDefault(_LangmanConstruction);
	
	var _DrJava = __webpack_require__(143);
	
	var _DrJava2 = _interopRequireDefault(_DrJava);
	
	var _ClintonCollege = __webpack_require__(141);
	
	var _ClintonCollege2 = _interopRequireDefault(_ClintonCollege);
	
	var _UnityPoint = __webpack_require__(142);
	
	var _UnityPoint2 = _interopRequireDefault(_UnityPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'content', id: 'content' },
	      _react2.default.createElement(
	        'section',
	        { className: 'section hero has-text-centered', style: { backgroundImage: 'url("' + _LangmanConstruction2.default + '")', backgroundSize: 'cover', textShadow: '0 0 10px black', position: 'relative', height: '650px', justifyContent: 'flex-end' } },
	        _react2.default.createElement('div', { style: { position: 'absolute', top: '0', bottom: '0', left: '0', right: '0', background: 'rgba(0,0,0,0.2)' } }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: 'has-text-white', style: { zIndex: '1' } },
	            'Elevations Quality'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { color: 'white', maxWidth: '650px', margin: '0 auto', zIndex: '1', fontWeight: '500' } },
	            'Decorative laminate provides a durable and easy-to-clean surface in a range of colors, textures, and patterns. These include Wilsonart\xAE and Formica\xAE brand laminates. Solid surfaces, such as Corian\xAE and Meganite\xAE are also available.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(_frontCat2.default, { title: 'Commercial Setting', img: _DrJava2.default, url: '/projects/commercial', desc: 'Elevations\' products are built to last. They can stand the test of time, so you can continue to serve your customers while our cabinets and countertops serve you.' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(_frontCat2.default, { title: 'Educational Setting', img: _ClintonCollege2.default, url: '/projects/educational', desc: 'We build custom desks and podiums for universities. Choose from a large palette of laminates and solid surface countertops to match any classroom setting.' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(_frontCat2.default, { title: 'Healthcare Setting', img: _UnityPoint2.default, url: '/projects/healthcare', desc: 'Our office furniture and receptionist stations are built to give you the most functionality and maximize your space while looking sleek and modern.' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ClintonCollege.0b7a9f98.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/LangmanConstruction.983dc282.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/UnityPoint.04e10c03.jpg";

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DrJava.47f94a7f.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ac376b586764c55e95ff.js